import { render } from "./TypeOwner.vue?vue&type=template&id=9d742bea&scoped=true"
import script from "./TypeOwner.vue?vue&type=script&lang=ts"
export * from "./TypeOwner.vue?vue&type=script&lang=ts"

import "./TypeOwner.vue?vue&type=style&index=0&id=9d742bea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9d742bea"

export default script